export class LoginData{
    userId: string;
    password: string;
    appId: string;
    wp_db_prefix: string;
}


// WEBPACK FOOTER //
// ./src/angular_library/models/login-data.ts